import { render, staticRenderFns } from "./myTab.vue?vue&type=template&id=5d9010b1&scoped=true"
import script from "./myTab.vue?vue&type=script&lang=js"
export * from "./myTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9010b1",
  null
  
)

export default component.exports